export default {
  SET_ACTIVE_NETWORK(state, network) {
    state.activeNetwork = network
  }
}
